<section class="campanhas-page planos">
  <header class="planos__cabecalho">
    <app-trilha-navegacao [passos]="trilha" />
    <h1 class="planos__titulo">Parâmetros de Plano</h1>
    <p class="planos__subtitulo">Cadastre e gerencie os planos previdenciários da entidade.</p>
  </header>

  <!-- Painel do filtro, no mesmo padrão do filtro da tela de resgate. -->
  <section class="planos__painel" aria-labelledby="planos-titulo-card" data-testid="planos-painel-filtro">
    <div class="planos__topo">
      <div class="planos__titulo-grupo">
        <h2 id="planos-titulo-card" class="planos__titulo-card">Planos Cadastrados</h2>
        <p class="planos__ajuda">Filtre por código, nome ou status.</p>
      </div>
      <vivest-button variant="primary" size="md" data-testid="planos-novo" (click)="novoPlano()">
        <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
        Novo Plano
      </vivest-button>
    </div>

    <form
      class="planos__filtros"
      aria-label="Filtrar planos"
      data-testid="planos-filtros"
      (submit)="$event.preventDefault(); pesquisar()"
    >
      <vivest-input
        class="planos__filtro"
        autocomplete=""
        error-message=""
        icon=""
        label="Código do Plano"
        name="codigo"
        placeholder="Digite o código"
        status="default"
        type="text"
        [value]="rascunho().codigo"
        (input)="atualizarRascunho('codigo', $event)"
        (keydown.enter)="pesquisar()"
        data-testid="planos-filtro-codigo"
      ></vivest-input>
      <vivest-input
        class="planos__filtro"
        autocomplete=""
        error-message=""
        icon=""
        label="Nome do Plano"
        name="nome"
        placeholder="Digite o nome"
        status="default"
        type="text"
        [value]="rascunho().nome"
        (input)="atualizarRascunho('nome', $event)"
        (keydown.enter)="pesquisar()"
        data-testid="planos-filtro-nome"
      ></vivest-input>
      <vivest-select
        class="planos__filtro planos__filtro--status"
        label="Status"
        name="status"
        status="default"
        [options]="statusOpcoes"
        [value]="rascunho().status"
        (change)="atualizarRascunho('status', $event)"
        data-testid="planos-filtro-status"
      ></vivest-select>

      <!-- Ação principal por último, no fim da linha de leitura. -->
      <div class="planos__acoes-filtro">
        <vivest-button variant="outline" size="md" data-testid="planos-limpar" (click)="limpar()">
          <vivest-icon slot="icon-left" name="rotate-ccw" source="feather"></vivest-icon>
          Limpar
        </vivest-button>
        <vivest-button variant="primary" size="md" data-testid="planos-pesquisar" (click)="pesquisar()">
          <vivest-icon slot="icon-left" name="search" source="feather"></vivest-icon>
          Pesquisar
        </vivest-button>
      </div>
    </form>
  </section>

  <!-- Lista sem painel em volta: a própria moldura branca da tabela é o card. -->
  <section class="planos__lista" aria-label="Lista de planos" data-testid="planos-painel-lista">
    @if (planos().length === 0) {
      <app-empty-state data-testid="planos-vazio" [message]="mensagemListaVazia()" />
    } @else {
      <div class="planos__tabela-scroll" (scroll)="fecharMenu()">
        <table class="planos__tabela" aria-label="Planos cadastrados" data-testid="planos-tabela">
          <thead>
            <tr>
              @for (coluna of colunas; track coluna.chave) {
                <th scope="col" [class]="'planos__coluna-' + coluna.chave">{{ coluna.rotulo }}</th>
              }
              <th scope="col" class="planos__coluna-acoes">Ações</th>
            </tr>
          </thead>
          <tbody>
            @for (plano of planos(); track plano.id) {
              <tr data-testid="planos-linha">
                <td class="planos__coluna-id planos__id">{{ plano.id }}</td>
                <td class="planos__coluna-codigo planos__codigo">{{ plano.codigo }}</td>
                <td class="planos__coluna-nome planos__nome">{{ plano.nome }}</td>
                <td class="planos__coluna-status">
                  <vivest-tag type="status" [variant]="varianteStatus(plano)">{{ plano.status }}</vivest-tag>
                </td>
                <td class="planos__coluna-ultimaAtualizacao planos__data">{{ data(plano) }}</td>
                <td class="planos__coluna-acoes">
                  <!-- Menu de ações do plano. "Editar" abre a parametrização; as demais pedem confirmação. -->
                  <vivest-icon-button
                    class="planos__mais"
                    variant="outline"
                    size="sm"
                    icon="more-vertical"
                    icon-source="feather"
                    aria-haspopup="menu"
                    [attr.aria-label]="'Ações do plano ' + identificacao(plano)"
                    [attr.aria-expanded]="menuAberto() === plano.id"
                    [attr.aria-controls]="menuAberto() === plano.id ? 'planos-menu-' + plano.id : null"
                    (click)="alternarMenu(plano, $event)"
                    data-testid="planos-mais"
                  ></vivest-icon-button>

                  @if (menuAberto() === plano.id) {
                    <ul
                      class="planos__menu"
                      role="menu"
                      [id]="'planos-menu-' + plano.id"
                      [attr.aria-label]="'Ações do plano ' + identificacao(plano)"
                      [style.top.px]="menuPosicao().top"
                      [style.bottom.px]="menuPosicao().bottom"
                      [style.right.px]="menuPosicao().right"
                      (keydown)="navegarMenu($event)"
                      data-testid="planos-menu"
                    >
                      @for (opcao of opcoesDe(plano); track opcao.id) {
                        <li role="none" [class.planos__menu-separado]="opcao.separada">
                          <button
                            type="button"
                            role="menuitem"
                            class="planos__menu-item"
                            [attr.data-testid]="'planos-menu-' + opcao.id"
                            (click)="escolherOpcao(plano, opcao)"
                          >
                            <vivest-icon [attr.name]="opcao.icone" source="feather" aria-hidden="true"></vivest-icon>
                            {{ opcao.rotulo }}
                          </button>
                        </li>
                      }
                    </ul>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Quantidade por página à esquerda, navegação entre páginas à direita. -->
      <footer class="planos__rodape">
        <div class="planos__tamanho" role="group" aria-label="Itens por página" data-testid="planos-tamanho-pagina">
          <span>Mostrar</span>
          @for (tamanho of tamanhosPagina; track tamanho; let ultimo = $last) {
            <button
              type="button"
              class="planos__tamanho-opcao"
              [class.planos__tamanho-opcao--atual]="tamanho === tamanhoPagina()"
              [attr.aria-pressed]="tamanho === tamanhoPagina()"
              [attr.data-testid]="'planos-tamanho-' + tamanho"
              (click)="alterarTamanhoPagina(tamanho)"
            >
              {{ tamanho }}
            </button>
            @if (!ultimo) {
              <span class="planos__tamanho-divisor" aria-hidden="true">|</span>
            }
          }
          <span>Itens por página</span>
        </div>

        <nav class="planos__paginacao" aria-label="Paginação">
          <button
            type="button"
            class="planos__pagina"
            aria-label="Primeira página"
            [disabled]="pagina() === 1"
            data-testid="planos-pagina-primeira"
            (click)="irParaPagina(1)"
          >
            <vivest-icon name="chevrons-left" source="feather" aria-hidden="true"></vivest-icon>
          </button>
          <button
            type="button"
            class="planos__pagina"
            aria-label="Página anterior"
            [disabled]="pagina() === 1"
            data-testid="planos-pagina-anterior"
            (click)="irParaPagina(pagina() - 1)"
          >
            <vivest-icon name="chevron-left" source="feather" aria-hidden="true"></vivest-icon>
          </button>
          @for (numero of paginas(); track numero) {
            <button
              type="button"
              class="planos__pagina"
              [class.planos__pagina--atual]="numero === pagina()"
              [attr.aria-current]="numero === pagina() ? 'page' : null"
              [attr.aria-label]="'Página ' + numero"
              [attr.data-testid]="'planos-pagina-' + numero"
              (click)="irParaPagina(numero)"
            >
              {{ numero }}
            </button>
          }
          <button
            type="button"
            class="planos__pagina"
            aria-label="Próxima página"
            [disabled]="pagina() === totalPaginas()"
            data-testid="planos-pagina-proxima"
            (click)="irParaPagina(pagina() + 1)"
          >
            <vivest-icon name="chevron-right" source="feather" aria-hidden="true"></vivest-icon>
          </button>
          <button
            type="button"
            class="planos__pagina"
            aria-label="Última página"
            [disabled]="pagina() === totalPaginas()"
            data-testid="planos-pagina-ultima"
            (click)="irParaPagina(totalPaginas())"
          >
            <vivest-icon name="chevrons-right" source="feather" aria-hidden="true"></vivest-icon>
          </button>
        </nav>
      </footer>
    }
  </section>

  <!--
    Confirmação de "Duplicar" e "Inativar"/"Ativar" (vivest-modal do design system). Fica sempre no DOM e abre
    por [open]; Esc (dismissible) e o fechamento nativo do <dialog> disparam vivest-close.
  -->
  <vivest-modal
    [heading]="tituloConfirmacao()"
    [description]="confirmacao()?.acao === 'duplicar' ? '' : descricaoConfirmacao()"
    [open]="confirmacao() !== null"
    [hasIcon]="false"
    dismissible=""
    (vivest-close)="cancelarConfirmacao()"
    data-testid="planos-confirmar"
  >
    <!-- "Duplicar" pede o plano de destino no slot "description" (o modal não tem slot de conteúdo livre): mesmo campo
         "Código do Plano" do cadastro, só com os planos ainda sem parametrização (uma por produto). -->
    @if (confirmacao()?.acao === 'duplicar') {
      <div slot="description" class="planos__copia">
        <p class="planos__copia-texto">{{ descricaoConfirmacao() }}</p>
        <vivest-autocomplete
          icon="search"
          label="Código do Plano"
          name="destinoCopia"
          placeholder="Busque pelo código ou nome"
          required
          [options]="opcoesDestino()"
          [attr.status]="erroDestinoCopia() ? 'error' : 'default'"
          [attr.error-message]="erroDestinoCopia()"
          (vivest-select)="selecionarDestino($event)"
          (input)="digitarDestino($event)"
          data-testid="planos-copia-codigo"
        ></vivest-autocomplete>
      </div>
    }
    <vivest-button
      slot="actions"
      variant="outline"
      size="md"
      data-testid="planos-confirmar-voltar"
      (click)="cancelarConfirmacao()"
    >
      Voltar
    </vivest-button>
    <vivest-button
      slot="actions"
      variant="primary"
      size="md"
      data-testid="planos-confirmar-acao"
      (click)="confirmarAcao()"
    >
      {{ acaoConfirmacao() }}
    </vivest-button>
  </vivest-modal>
</section>
